import { Checkbox, Text } from '@fluentui/react-components';
import { get } from 'es-toolkit/compat';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useStores } from '../../../common/hooks';
import { UploadedMedia } from '../../../models';
import DocumentFile from '../../shared-components/DocumentFile';
import './UploadMediaSection.scss';

const UploadMediaSectionImpl: React.FC = () => {
  const {
    reviewQuestionnairePageUiStore,
  } = useStores();

  const media: UploadedMedia[] = get(reviewQuestionnairePageUiStore, 'questionnaire.media', []);

  return (
    <section
      className='review-questionnaire-page__section review-questionnaire-page__section--media'
    >
      <Text
        block
        weight='semibold'
        size={400}
        as='h3'
      >
        Media
      </Text>
      <Text as='i' italic>Images</Text>
      {
        media.length > 0 &&
        <div>
          {
            media
              .filter(item => ['.jpg', '.png', '.gif', '.tif', '.eps', '.svg'].some(value => item.originalFileName.indexOf(value) > -1))
              .map(medium => {
                return (
                  <DocumentFile
                    key={medium.uploadedMediaId}
                    filename={medium.originalFileName}
                  />
                );
              })
          }
        </div>
      }
      <Text as='i' italic>Video files</Text>
      {
        media.length > 0 &&
        <div>
          {
            media
              .filter(item => ['.mp4', '.wmv', '.asx'].some(value => item.originalFileName.indexOf(value) > -1))
              .map(medium => {
                return (
                  <DocumentFile
                    key={medium.uploadedMediaId}
                    filename={medium.originalFileName}
                  />
                );
              })
          }
        </div>
      }
      <Checkbox
        label='I affirm that the individuals in these photographs/videos consented to having their image shared with Microsoft for the purpose of being featured in the award winner recognition segment of Microsoft Ignite.'
        checked={reviewQuestionnairePageUiStore.questionnaire?.mediaConsentDisclaimer ?? false}
        readOnly
      />
    </section>
  );
}

export const UploadMediaSection = observer(UploadMediaSectionImpl);
